/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Button, INodeProps } from '@msdyn365-commerce-modules/utilities';

export interface IShowContactInfoInput {
    canEdit: boolean;
    email: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    companyName?: string;
    resources: {
        editBtnLabel: string;
    };
    onEdit(): void;
}

export interface IShowContactInfo {
    showInfoProps: INodeProps;
    email: React.ReactNode;
    editButton?: React.ReactNode;
    firstName?: React.ReactNode;
    lastName?: React.ReactNode;
    phoneNumber?: React.ReactNode;
    companyName?: React.ReactNode;
}

const getContactInfo = ({ canEdit, email, firstName, lastName, phoneNumber, companyName,  resources: { editBtnLabel }, onEdit }: IShowContactInfoInput): IShowContactInfo => ({
    showInfoProps: { className: 'ms-checkout-guest-profile__selected-item' },
    firstName: <span className='ms-checkout-guest-profile__selected-firstname'>{firstName}</span>,
    lastName: <span className='ms-checkout-guest-profile__selected-lastname'>{lastName}</span>,
    email: <span className='ms-checkout-guest-profile__selected-email'>{email}</span>,
    phoneNumber: <span className='ms-checkout-guest-profile__selected-phonenumber'>{phoneNumber}</span>,
    companyName: <span className='ms-checkout-guest-profile__selected-companyname'>{companyName}</span>,
    editButton: canEdit && (
    <Button className='ms-checkout-guest-profile__btn-edit' title={editBtnLabel} color='link' onClick={onEdit} >{editBtnLabel}</Button>
    )
});

export default getContactInfo;
